<template>
  <NovaRequisicaoBalcaoComponent
    :category="1"
    :title="'Requisição Balcão EPIs'"
  />
</template>

<script>
import NovaRequisicaoBalcaoComponent from "../components/NovaRequisicaoBalcaoComponent.vue";
export default {
  components: {
    NovaRequisicaoBalcaoComponent,
  },
};
</script>

<style></style>
